import * as yup from "yup";

import { dobValidationSchemaFactory } from "../../../utils/yupSchemaUtils";

export const A5_START_INITIAL_VALUES = {
  current_house: "",
  dob: "",
  ethnicity: "",
  first_name: "",
  gender: "",
  hours_work_per_week: "",
  last_name: "",
  marital_status: "",
  middle_name: "",
  persons_living: "",
};

export const A5_START_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First Name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Middle Name",
      placeholder: "Middle Name",
      type: "text",
    },
    elementType: "input",
    name: "middle_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last Name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "DatePicker",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Ethnicity",
      options: [
        { display: "American Indian", value: "american_indian" },
        { display: "African American", value: "african_american" },
        { display: "Alaska Native", value: "alaska_native" },
        { display: "Asian", value: "asian" },
        { display: "White", value: "white" },
        { display: "Hispanic/Latino", value: "hispanic_latino" },
        { display: "Pacific Islander", value: "pacific_islander" },
        { display: "Multiracial", value: "multiracial" },
        { display: "Other", value: "other" },
      ],
      placeholder: "Ethnicity",
    },
    elementType: "select",
    name: "ethnicity",
  },
  {
    elementConfig: {
      label: "Marital Status",
      options: [
        { display: "Single", value: "single" },
        { display: "Married", value: "married" },
        { display: "Separated", value: "separated" },
        { display: "Divorced", value: "divorced" },
        { display: "Remarried", value: "remarried" },
        { display: "Widowed", value: "widowed" },
        { display: "Other", value: "other" },
      ],
      placeholder: "Marital Status",
    },
    elementType: "select",
    name: "marital_status",
  },
  {
    elementConfig: {
      label: "Current Housing",
      options: [
        { display: "Own House/Condo", value: "own_house_condo" },
        { display: "Rent House", value: "rent_house" },
        { display: "Rent Apartment", value: "rent_apartment" },
        { display: "Someone Else’s Home", value: "someones_house" },
        { display: "Supported Housing", value: "supported_housing" },
        { display: "Shelter", value: "shelter" },
        { display: "Homeless", value: "homeless" },
        { display: "Other", value: "other" },
      ],
      placeholder: "Current Housing",
    },
    elementType: "select",
    name: "current_house",
  },
  {
    elementConfig: {
      label: "Who I currently live with:",
      options: [
        { display: "Alone", value: "alone" },
        { display: "Spouse", value: "spouse" },
        { display: "Spouse/Children", value: "spouse_children" },
        { display: "Partner", value: "partner" },
        { display: "Partner/Children", value: "partner_children" },
        { display: "Children", value: "children" },
        { display: "Parent(s)", value: "parents" },
        { display: "Other Family", value: "other_family" },
        { display: "Friends", value: "friends" },
        { display: "Other", value: "other" },
      ],
      placeholder: "Who I currently live with:",
    },
    elementType: "select",
    name: "persons_living",
  },
  {
    elementConfig: {
      label: "Hours I work in a week:",
      options: [
        { display: "Do not work", value: "no_work" },
        { display: "Less than 20 hours", value: "lt_20" },
        { display: "21-40 hours", value: "gt_20_lte_40" },
        { display: "41-50 hours", value: "gt_40_lte_50" },
        { display: "51-60", value: "gt_50_lte_60" },
        { display: "More than 60 hours", value: "gt_60" },
      ],
      placeholder: "Hours I work in a week",
    },
    elementType: "select",
    name: "hours_work_per_week",
  },
];

export const A5_START_VALIDATION_SCHEMA = yup.object().shape({
  current_house: yup.string().required("Current Housing is required"),
  dob: dobValidationSchemaFactory("MMDDYYYY").required("Required"),
  ethnicity: yup.string().required("Ethnicity is required"),
  first_name: yup
    .string()
    .required("First Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  gender: yup.string().required("Gender is required"),
  hours_work_per_week: yup.string().required("Hours I work in a week is required"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  marital_status: yup.string().required("Marital Status is required"),
  middle_name: yup
    .string()
    .matches(/^[a-zA-Z-]+$/, "Digits, space & special characters are not allowed"),
  persons_living: yup.string().required("Person(s) I live with is required"),
});
